import {maybe} from '@freckle/maybe'

export function snakeCaseToSpaces(str: string): string {
  return str.replace(/_/g, ' ')
}

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/* This is used when setting cookies so, for example, a cookie can be sent to
  api.freckle.com when we are on classroom.freckle.com. */
function removeHostSubdomain(url: string): string {
  return url.split('.').slice(1).join('.')
}

export function createSecureCookieString(
  name: string,
  value: string,
  domain: string,
  expiration?: Date | null,
  path?: string | null
): string {
  const domainWithoutSubdomain = removeHostSubdomain(domain)
  const expiresElem = maybe(
    () => [],
    e => [`expires=${e.toUTCString()}`],
    expiration
  )
  const pathElem = maybe(
    () => [],
    p => [`path=${p}`],
    path
  )
  const cookieElements = [
    `${name}=${value}`,
    `domain=.${domainWithoutSubdomain}`,
    'secure',
    ...expiresElem,
    ...pathElem
  ]
  return cookieElements.join('; ')
}

export function pluralize(num: number, singularForm: string, pluralForm: string): string {
  return num === 1 ? singularForm : pluralForm
}

// iOS 11 and macOS High Sierra automatically replace single and double-quote
// keystrokes with smart quotes. This breaks student login if either the student
// or teacher is not using iOS/macOS and the other user is.
export function replaceSmartQuotes(text: string): string {
  return text.replace(/[‘’]/g, "'").replace(/[“”]/g, '"')
}
